// Version configuration for Red Helicopter Platform
export const APP_VERSION = {
  major: 1,
  minor: 1,
  patch: 0,
  build: 'e0e21d7b', // Git commit hash
  stage: 'production',

  // Full version string
  get full(): string {
    return `${this.major}.${this.minor}.${this.patch}-${this.stage}.${this.build}`;
  },

  // Display version (for UI)
  get display(): string {
    return `v${this.major}.${this.minor}`;
  },

  // Detailed version (for debugging)
  get detailed(): string {
    return `v${this.major}.${this.minor}.${this.patch} (${this.stage}, build ${this.build})`;
  }
};

// Export for use in components
export const VERSION = APP_VERSION.display;
export const VERSION_FULL = APP_VERSION.full;
export const VERSION_DETAILED = APP_VERSION.detailed;